const stickyAddToCart = document.querySelector('.sticky_cart');

if (stickyAddToCart && window.innerWidth > 768) {
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const scrollAmount = window.scrollY;
        console.log(scrollAmount);
        stickyAddToCart.classList.toggle('active', scrollAmount >= 300);
        ticking = false;
      });
      ticking = true;
    }
  });
}

/* custom hover functionality for header dropdown menus */
(function () {
  const menuItems = document.querySelectorAll('.header__menu-item');
  const body = document.querySelector('body');

  // Find every trigger by convention: id ends in "_trigger"
  // and has a matching "_menu" element (e.g. shop_trigger / shop_menu)
  const dropdowns = [];

  document.querySelectorAll('[id$="_trigger"]').forEach((trigger) => {
    const key = trigger.id.replace(/_trigger$/, '');
    const menu = document.getElementById(`${key}_menu`);
    if (!menu) return;

    dropdowns.push({
      key,
      trigger,
      menu,
      bodyClass: `${key}_menu_open`,
    });
  });

  if (!dropdowns.length) return;

  function openDropdown(dropdown) {
    dropdown.trigger.setAttribute('aria-expanded', 'true');
    dropdown.menu.classList.add('active');
    body.classList.add(dropdown.bodyClass);
  }

  function closeDropdown(dropdown) {
    dropdown.trigger.setAttribute('aria-expanded', 'false');
    dropdown.menu.classList.remove('active');
    body.classList.remove(dropdown.bodyClass);
  }

  function closeAllExcept(exceptKey) {
    dropdowns.forEach((d) => {
      if (d.key !== exceptKey) closeDropdown(d);
    });
  }

  dropdowns.forEach((dropdown) => {
    // Open this one, close all others
    dropdown.trigger.addEventListener('mouseenter', () => {
      closeAllExcept(dropdown.key);
      openDropdown(dropdown);
    });

    // Close this one when leaving its menu
    dropdown.menu.addEventListener('mouseleave', () => {
      closeDropdown(dropdown);
    });
  });

  // Close all dropdowns when hovering any top-level menu item
  // that isn't itself a dropdown trigger
  menuItems.forEach((item) => {
    const isTrigger = dropdowns.some((d) => d.trigger.id === item.id);
    if (!isTrigger) {
      item.addEventListener('mouseenter', () => {
        closeAllExcept(null);
      });
    }
  });
})();


/* custom product variant dropdown for non color options */
document.querySelectorAll('fieldset.dropdown').forEach(dropdown => {
  const selectedValue = dropdown.querySelector('.selected-value');
  const options = dropdown.querySelector('.custom_option_group');
  const radios = dropdown.querySelectorAll('input[type="radio"]');
  const labels = dropdown.querySelectorAll('label');

  // Initialize selected value
  const initialChecked = dropdown.querySelector('input[type="radio"]:checked');
  if (initialChecked) {
    selectedValue.textContent = initialChecked.value;
  } else if (radios.length > 0) {
    selectedValue.textContent = radios[0].value;
  }

  // Toggle dropdown open/close when clicking the selected value
  selectedValue.addEventListener('click', () => {
    dropdown.classList.toggle('open');
  });

  // Update selected value and close dropdown when clicking **any label**
  labels.forEach(label => {
    label.addEventListener('click', () => {
      const input = document.getElementById(label.getAttribute('for'));
      if (input) {
        selectedValue.textContent = input.value;
      }
      dropdown.classList.remove('open');
    });
  });

  // Close dropdown if clicking outside
  document.addEventListener('click', e => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('open');
    }
  });
});


/* custom product variant tooltips on hover */

function createToolTips() {
  // Create tooltip element once (same as your existing code)
  const tooltip = document.createElement("div");
  // ... your existing tooltip styling code ...
  tooltip.style.position = "absolute";
  tooltip.style.padding = "6px 10px";
  tooltip.style.background = "#393939";
  tooltip.style.color = "#fff";
  tooltip.style.borderRadius = "4px";
  tooltip.style.fontSize = "12px";
  tooltip.style.whiteSpace = "nowrap";
  tooltip.style.pointerEvents = "none";
  tooltip.style.zIndex = "9999";
  tooltip.style.textTransform = "capitalize";
  tooltip.style.display = "none"; // hidden by default
  document.body.appendChild(tooltip);

  // Use event delegation on the entire document
  document.body.addEventListener('mouseover', function(event) {
    // Check if the hovered element OR any of its parents has the tooltip_hover class
    const tooltipEl = event.target.closest('.tooltip_hover');
    
    if (tooltipEl) {
      const color = tooltipEl.getAttribute("data-name");
      tooltip.textContent = color;
      tooltip.style.display = "block";

      const rect = tooltipEl.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();

      const left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
      const top = rect.bottom + 6;

      tooltip.style.left = left + window.scrollX + "px";
      tooltip.style.top = top + window.scrollY + "px";
    }
  });

  document.body.addEventListener('mouseout', function(event) {
    // Check if we're moving away from a tooltip element
    if (event.target.closest('.tooltip_hover')) {
      // Check if we're moving to something that's not a child of the tooltip
      if (!event.relatedTarget || !event.relatedTarget.closest('.tooltip_hover')) {
        tooltip.style.display = "none";
      }
    }
  });
}

// masonry grids - waiting for dom to be loaded
document.addEventListener("DOMContentLoaded", function () {

  // if on product detail page setup custom toolTips
  if (document.querySelector("body").classList.contains("product")) {
    createToolTips();
  }

  let masonGrids = document.querySelectorAll('.mason_grid');
  masonGrids.forEach(masonGrid => {
    var msnry = new Masonry(masonGrid, {
      itemSelector: '.cell',
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
    });
  })

});

// blog / everyday objects filter functionality
let blogFilterEls = document.querySelectorAll(".blog-filter li .trigger");
blogFilterEls.forEach(blogFilterEl => {
  let filterParent = blogFilterEl.closest("li");
  blogFilterEl.addEventListener("click", function(e) {
    e.preventDefault();
    filterParent.classList.toggle("open");
  });
});

// blog filter functionality
const articles = document.querySelectorAll('.blog-articles__article');
let blogFilterTriggerEls = document.querySelectorAll(".blog-filter li.filter");
const filterSelectedC = document.querySelector(".filter_parent.contributor .selected");
const filterSelectedV = document.querySelector(".filter_parent.volume .selected");
const filterSelectedT = document.querySelector(".filter_parent.type .selected");

function toSentenceCase(str) {
  return str
    .replace(/-/g, " ")                   // replace hyphens with spaces
    .toLowerCase()                        // normalize to lowercase
    .replace(/\b\w/g, c => c.toUpperCase()); // capitalize each word
}

function getFiltersFromURL() {
  const params = new URLSearchParams(window.location.search);
  return {
    contributor: params.get('contributor') || '',
    volume: params.get('volume') || '',
    type: params.get('type')
  };
}

function filterArticles(filter) {
  articles.forEach(article => {
    const contributor = article.dataset.contributor?.toLowerCase() || '';
    const volume = article.dataset.volume?.toLowerCase() || '';
    const type = article.dataset.type?.toLowerCase() || '';

    // For each filter key, ensure the article matches
    const matchesContributor = !filter.contributor || contributor.includes(filter.contributor.toLowerCase());
    const matchesVolume = !filter.volume || volume.includes(filter.volume.toLowerCase());
    const matchesType = !filter.type || type.includes(filter.type.toLowerCase());

    // Show or hide article
    if (matchesContributor && matchesVolume && matchesType) {
      article.style.display = 'flex';
    } else {
      article.style.display = 'none';
    }
  });
}


// on page load check for query parameters
if (articles.length > 0) {
  const params = new URLSearchParams(window.location.search);
  const pageFilters = getFiltersFromURL();

  if (pageFilters.contributor != "" && pageFilters.contributor != null) {
    filterArticles({ contributor: pageFilters.contributor });
    filterSelectedC.innerHTML = toSentenceCase(pageFilters.contributor);
    filterSelectedV.innerHTML = "All";
    filterSelectedT.innerHTML = "All";
  } else if (pageFilters.volume != "" && pageFilters.volume != null) {
    filterArticles({ volume: pageFilters.volume });
    filterSelectedC.innerHTML = "All";
    filterSelectedV.innerHTML = pageFilters.volume;
    filterSelectedT.innerHTML = "All";
  } else if (pageFilters.type != "" && pageFilters.type != null) {
    filterArticles({ type: pageFilters.type });
    filterSelectedC.innerHTML = "All";
    filterSelectedV.innerHTML = "All";
    filterSelectedT.innerHTML = toSentenceCase(pageFilters.type);
  } else {
    // default to volume 2025
    filterArticles({ volume: '2025'});
    filterSelectedC.innerHTML = "All";
    filterSelectedV.innerHTML = "2025";
    filterSelectedT.innerHTML = "All";
  }
}

// filter click events

blogFilterTriggerEls.forEach(blogFilterTriggerEl => {

  blogFilterTriggerEl.addEventListener("click", function(e) {
    e.preventDefault();

    // close the filter
    let filterParent = blogFilterTriggerEl.closest(".blog-filter li.open");
    filterParent.classList.remove("open");

    // filter the work grid by selected value
    if (blogFilterTriggerEl.classList.contains("contributor")) {
      let selected = blogFilterTriggerEl.getAttribute("data-contributor");

      // update the selected label
      filterSelectedC.innerHTML = toSentenceCase(selected);
      filterSelectedV.innerHTML = "All";
      filterSelectedT.innerHTML = "All";

      // update the URL
      const filters = {
        contributor: selected
      };

      const params = new URLSearchParams(filters);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      history.replaceState({}, '', newUrl);

      // update the grid
      filterArticles({ contributor: selected });
    }

    if (blogFilterTriggerEl.classList.contains("volume")) {
      let selected = blogFilterTriggerEl.getAttribute("data-volume");

      // update the URL
      const filters = {
        volume: selected
      };

      // update the selected label
      filterSelectedV.innerHTML = selected;
      filterSelectedC.innerHTML = "All";
      filterSelectedT.innerHTML = "All";

      const params = new URLSearchParams(filters);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      history.replaceState({}, '', newUrl);

      // update the grid
      filterArticles({ volume: selected });
    }

    if (blogFilterTriggerEl.classList.contains("type")) {
      let selected = blogFilterTriggerEl.getAttribute("data-type");

      // update the URL
      const filters = {
        type: selected
      };

      // update the selected labels
      filterSelectedT.innerHTML = toSentenceCase(selected);
      filterSelectedV.innerHTML = "All";
      filterSelectedC.innerHTML = "All";

      const params = new URLSearchParams(filters);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      history.replaceState({}, '', newUrl);

      // update the grid
      filterArticles({ type: selected });
    }
  });
});

// mobile cart link needs to trigger main cart drawer
let mobileCartLink = document.querySelector('#cart-icon-bubble-mobile');
if (typeof mobileCartLink != 'undefined' && mobileCartLink != null) {
  mobileCartLink.addEventListener('click', function (e) {
    e.preventDefault();
    document.getElementById('cart-icon-bubble').click();
  });
}

let newsletterTrigger = document.querySelector('.newsletter_trigger');
if (typeof newsletterTrigger != 'undefined' && newsletterTrigger != null) {
  let newsletterEl = document.getElementById('newsletter_form');
  let newsletterCloserEl = newsletterEl.querySelector(".close");
  newsletterTrigger.addEventListener('click', function (e) {
    e.preventDefault();
    newsletterEl.classList.add('show');
  });

  // clicking the X closes newsletter
  newsletterCloserEl.addEventListener('click', function (e) {
    newsletterEl.classList.remove('show');
  });
}

// hover events for main header drop-down menus
let items = document.querySelector('.header__inline-menu').querySelectorAll('details');
items.forEach((item) => {
  item.addEventListener('mouseover', () => {
    // close the search modal
    if (typeof searchEl != 'undefined' && searchEl != null) {
      searchEl.classList.remove('on');
    }
    item.setAttribute('open', true);
    item.querySelector('ul').addEventListener('mouseleave', () => {
      item.removeAttribute('open');
    });
    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
    });
  });
});

// header search trigger
let headerSearchTriggerEls = document.querySelectorAll('header a.searchTrigger');
let searchEl = document.getElementById('search_wrap');
headerSearchTriggerEls.forEach((headerSearchTriggerEl) => {
  headerSearchTriggerEl.addEventListener('click', function (e) {
    e.preventDefault();
    searchEl.classList.toggle('on');
    if (searchEl.classList.contains('on')) {
      document.querySelector('header #Search-In-Modal').focus();
    }
  });
});

// ajax request to add to cart and then open cart drawer
let silentAddItems = document.querySelectorAll('.silent_add_to_cart');
silentAddItems.forEach((silentAddItem) => {
  silentAddItem.addEventListener('click', function (e) {
    e.preventDefault();

    const form = silentAddItem.closest('form');
    const formData = new FormData(form);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    config.body = formData;

    // ajax request to add to cart
    fetch('/cart/add', config)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart) {
          cart.renderContents(response);

          cart.classList.remove('is-empty');
        }
      });
  });
});

// audio controls for autoplay videos
let audioMuteEls = document.querySelectorAll('.icon_muted');
let audioUnmuteEls = document.querySelectorAll('.icon_sound');

audioMuteEls.forEach((audioMuteEl) => {
  audioMuteEl.addEventListener('click', function (e) {
    e.preventDefault();
    let section = audioMuteEl.closest('.section');
    let videoEl = section.querySelector('video');
    videoEl.muted = false;
    section.classList.add('sound');
  });
});

audioUnmuteEls.forEach((audioUnmuteEl) => {
  audioUnmuteEl.addEventListener('click', function (e) {
    e.preventDefault();
    let section = audioUnmuteEl.closest('.section');
    let videoEl = section.querySelector('video');
    videoEl.muted = true;
    section.classList.remove('sound');
  });
});

// scroll event to hide/show down arrow
let st = 0;

window.addEventListener('scroll', function () {
  st = window.pageYOffset || document.documentElement.scrollTop;
  if (this.document.querySelector('body').classList.contains('index')) {
    if (st > 100) {
      this.document.querySelector('.scroll_down_arrow').classList.add('hide');
    } else {
      this.document.querySelector('.scroll_down_arrow').classList.remove('hide');
    }
  }
});

// handle trade faq button for scrolling with div
let tradeFaqButton = document.querySelector('button.trade_faq_link');
if (typeof tradeFaqButton != 'undefined' && tradeFaqButton != null) {
  tradeFaqButton.addEventListener('click', function (e) {
    e.preventDefault();
    var defaultDuration = 800;
    var edgeOffset = 30;
    var myDiv = document.querySelector('.trade_form_column');
    var myScroller = zenscroll.createScroller(myDiv, defaultDuration, edgeOffset);
    var target = document.getElementById('faq');
    myScroller.to(target);
  });
}

let scrollDownArrowEl = document.querySelector('.scroll_down_arrow');
if (typeof scrollDownArrowEl != 'undefined' && scrollDownArrowEl != null) {
  scrollDownArrowEl.addEventListener('click', function () {
    zenscroll.toY(innerHeight);
  });
}

// product detail scroll to additional info and downloads
let productAdditionalInfoTrigger = document.querySelector('.additional_scroll');
if (typeof productAdditionalInfoTrigger != 'undefined' && productAdditionalInfoTrigger != null) {

  // make sure there are more details on the page, if not hide.  For example Bulbs don't have additional details
  let additionDetailsCheck = document.querySelector(".additional_details");
  if (!additionDetailsCheck) {
    productAdditionalInfoTrigger.style.display = "none";
  }

  productAdditionalInfoTrigger.addEventListener('click', function () {
    zenscroll.to(document.getElementById('additional_anchor'));
  });
}

// create a function to get cookies
function getCookie(name) {
  let cookieArr = document.cookie.split(';');
  for (let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split('=');
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

document.addEventListener('DOMContentLoaded', function () {
  // on product detail page we need to check that the product info content isn't taller than screenheight
  let productInfoContentEl = document.querySelector('.hero .inner .product_top .info .wrap');

  function checkProductColHeight() {
    let productInfoColEl = document.querySelector('.hero .inner .product_top .info');
    let productInfoContentHeight = productInfoContentEl.offsetHeight;
    let windowHeight = window.innerHeight;
    if (productInfoContentHeight > windowHeight - 100) {
      productInfoColEl.classList.add('scrollable');
    } else {
      productInfoColEl.classList.remove('scrollable');
    }
  }

  if (typeof productInfoContentEl != 'undefined' && productInfoContentEl != null) {
    checkProductColHeight();
  }

  // on window resize we need to check that the product info content isn't taller than screenheight
  window.addEventListener('resize', function () {
    if (typeof productInfoContentEl != 'undefined' && productInfoContentEl != null) {
      checkProductColHeight();
    }
  });

  // need to re-order the input and label elements in the TRADE forms
  let tradeFields = document.querySelectorAll('.trade_account .field');
  tradeFields.forEach((tradeField) => {
    let inputEl = tradeField.querySelector('input');
    let labelEl = tradeField.querySelector('label');
    let placeHolder = labelEl.innerHTML;
    inputEl.setAttribute('placeholder', placeHolder);
    tradeField.insertBefore(inputEl, labelEl);
  });

  let addTradeFields = document.querySelectorAll('.rendered-form .form-group');
  addTradeFields.forEach((tradeField) => {
    let inputEl = tradeField.querySelector('input');
    let labelEl = tradeField.querySelector('label');
    if (inputEl) {
      tradeField.insertBefore(inputEl, labelEl);
    }
  });

  /*
  // check for cookie to show site pop-up newsletter
  let newsletterCookie = getCookie('newsletter_popup');
  if (newsletterCookie != 'true') {
    // show the newsletter pop-up after a short delay
    setTimeout(function () {
      document.querySelector('.overlay').classList.add('show');
    }, 1000);
    let newsletterCloserEl = document.querySelector('.overlay .closer');
    newsletterCloserEl.addEventListener('click', function () {
      document.querySelector('.overlay').classList.remove('show');
      // set cookie to prevent newsletter pop-up from showing again for 7 days
      let date = new Date();
      date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
      document.cookie = 'newsletter_popup=true; expires=' + date.toUTCString() + '; path=/';
    });
    let newsletterCloserForeverEl = document.querySelector('.overlay a.hide_newsletter');
    newsletterCloserForeverEl.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector('.overlay').classList.remove('show');
      // set cookie to prevent newsletter pop-up from showing.  Set expiration date for 10 years from today
      let expirationDate = new Date();
      expirationDate.setFullYear(expirationDate.getFullYear() + 10);
      const expires = expirationDate.toUTCString();
      document.cookie = 'newsletter_popup=true; expires=' + expires + '; path=/';
    });
  }
    */

  // product detail main slideshow
  const productSlideshow = document.querySelector('.slideshow.product_detail');

  var flkty;

  // make sure productSlideshow exists on the page
  if (typeof productSlideshow != 'undefined' && productSlideshow != null) {

    let nextArrow = productSlideshow.querySelector('.arrow.next');
    let prevArrow = productSlideshow.querySelector('.arrow.previous');

    // Find selected color swatch on page load and mark slides active/inactive before Flickity initializes
    let selectedColorInput = document.querySelector('input[type="radio"][data-primary="yes"]:checked');
    let selectedColorSwatch = selectedColorInput ? selectedColorInput.nextElementSibling : null;

    if (selectedColorSwatch) {
      productSlideshowSetup(selectedColorSwatch);
    } else {
      // mark all slides as active, no colors
      let allSlides = document.querySelectorAll(".slideshow.product_detail .slide");
      for (let i = 0; i < allSlides.length; i++) {
        allSlides[i].setAttribute('data-status', 'active');
      }
    }

    flkty = new Flickity(productSlideshow, {
      cellSelector: '.slide[data-status="active"]',
      prevNextButtons: false,
      wrapAround: false,
      pageDots: false,
      speed: 700,
      cellAlign: 'left',
      on: {
        ready: function () {
          let selectedVariant = document.querySelector('input[type="radio"][data-primary="yes"]:checked');
          if (typeof selectedVariant != "undefined" && selectedVariant != null) {
            let selectedLabel = selectedVariant.nextElementSibling;
            setTimeout(function() {
              productSlideshowSelect(selectedLabel);
              productSlideshow.classList.add('ready');
            }, 100);
          } else {
            productSlideshow.classList.add('ready');
          }
          setTimeout(function() {
            updateArrowStates();
          }, 500);
        },
      },
    });

    function updateArrowStates() {
      let isFirst = flkty.selectedIndex === 0;
      let isLast = flkty.selectedIndex === flkty.cells.length - 1;
      prevArrow.classList.toggle('disabled', isFirst);
      nextArrow.classList.toggle('disabled', isLast);
    }

    // Update arrows whenever the slide changes
    flkty.on('change', updateArrowStates);
    
    nextArrow.addEventListener('click', function (e) {
      e.preventDefault();
      // check if next slide has data-status of active, if found advance, if not stop
      let currentCell = flkty.selectedElement;
      let nextCell = currentCell.nextElementSibling;
      if (!nextCell) {
        nextCell = flkty.cells[0].element;
      }
      let nextCellStatus = nextCell.getAttribute('data-status');
      if (nextCellStatus == 'active') {
        flkty.next();
      }
      
    });
    
    prevArrow.addEventListener('click', function (e) {
      e.preventDefault();
      // check if previous slide has data-status of active, if found advance, if not stop
      let currentCell = flkty.selectedElement;
      let nextCell = currentCell.previousElementSibling;
      if (!nextCell) {
        nextCell = flkty.cells[flkty.cells.length - 1].element;
      }
      let nextCellStatus = nextCell.getAttribute('data-status');
      console.log(nextCellStatus);
      if (nextCellStatus == 'active') {
        flkty.previous();
      }
    });

    function arraysHaveExactMatch(arr1, arr2) {
      return arr1.length === arr2.length && arr1.every(item => arr2.includes(item));
    }

    function countMatches(arr1, arr2, loopIndex) {

        // Convert all values to strings for a consistent comparison
        const normalizedArr1 = arr1.map(String);
        const normalizedArr2 = arr2.map(String);
    
        // Count matches
        const matchCount = normalizedArr1.filter(item => normalizedArr2.includes(item)).length;
    
        // Return match count along with loop index
        return { loopIndex, matchCount };
    }
    
    function productSlideshowSelect(variantOptionEl) {

        let variantOptionsSelected = getSelectedVariantOptions(variantOptionEl);
        advanceToMatchingSlide(variantOptionsSelected);

        /*

        let imageSlides = productSlideshow.querySelectorAll('.slide[data-status="active"]');

        // set the selected options array to empty
        let variantOptionsSelected = [];

        // code below to advance the slideshow to the matching color variant image
        let foundMatch = false;
        let foundMatchStatus = false;
        let variantOptionValue = variantOptionEl.getAttribute('data-name');

        // find all .product-form__input elements and remove selected class from them
        let productFormInputEls = document.querySelectorAll('.product-form__input');
        productFormInputEls.forEach((productFormInputEl) => {
          productFormInputEl.classList.remove('selected');
        });

        // find the closest product-form__input element and add selected class to it.
        let productFormInputEl = variantOptionEl.closest('.product-form__input');
        productFormInputEl.classList.add('selected');

        // add the selected variant option name to the variantOptionsSelected array
        variantOptionsSelected.push(variantOptionValue);

        // loop through all product-form__input elements that don't have the class selected and find checked radio inputs
        let uncheckedProductFormInputEls = document.querySelectorAll(
          '.product-form__input:not(.selected) input[type="radio"]:checked'
        );
        uncheckedProductFormInputEls.forEach((uncheckedProductFormInputEl) => {
          // add the unchecked variant option name to the variantOptionsSelected array
          variantOptionsSelected.push(uncheckedProductFormInputEl.value.replace('"', ''));
        });

        console.log(variantOptionsSelected);

        // loop through product slides and find first matching slide class with variant option value - EXACT MATCH
        for (let i = 0; i < imageSlides.length; i++) {
          let imageSlide = imageSlides[i];
          let slideAlt = imageSlide.getAttribute('data-alt');

          // create an array from the slide alt text using a comma as the separator
          let slideAltTextArray = slideAlt.split(',');

          //console.log(slideAltTextArray);

          if (arraysHaveExactMatch(variantOptionsSelected, slideAltTextArray)) {
            // get the flickity cell index by finding the position of this slide within Flickity's cells
            let flickityIndex = flkty.cells.findIndex(cell => cell.element === imageSlide);
            flkty.select(flickityIndex, false, true);
            foundMatch = true;
            break;
          }
        }

        // if foundMatch is false after looping through all options, default to first option
        if (!foundMatch) {

          let highestMatch = { element: null, matchCount: 0 };

          for (let i = 0; i < imageSlides.length; i++) {
            let imageSlide = imageSlides[i];
            let slideAlt = imageSlide.getAttribute('data-alt');
            let slideAltTextArray = slideAlt.split(',');

            const result = countMatches(variantOptionsSelected, slideAltTextArray, i);

            if (result.matchCount > highestMatch.matchCount) {
              highestMatch = { element: imageSlide, matchCount: result.matchCount };
            }
          }

          if (highestMatch.element) {
            let flickityIndex = flkty.cells.findIndex(cell => cell.element === highestMatch.element);
            console.log("highest match - " + flickityIndex);
            flkty.select(flickityIndex, false, true);
          }

        }

        */
      
    }

    function productSlideshowSetup(variantColorEl) {

      let imageSlides = productSlideshow.querySelectorAll('.slide');

      let selectedColor = variantColorEl.getAttribute('data-name');

      // loop through product slides - add data-attribute for matches. just checking if color is found in data-alt
      for (let i = 0; i < imageSlides.length; i++) {

        let imageSlide = imageSlides[i];
        let slideAlt = imageSlide.getAttribute('data-alt');
        let slideAltTextArray = slideAlt ? slideAlt.split(',').map(s => s.trim()) : [];

        if (slideAltTextArray.some(val => val.toLowerCase() === selectedColor.toLowerCase())) {
          imageSlides[i].setAttribute('data-status', 'active');
        } else {
          imageSlides[i].setAttribute('data-status', 'inactive');
        }

      }

    }

    function productSlideshowBuild(variantColorEl) {

      let imageSlides = productSlideshow.querySelectorAll('.slide');

      let selectedColor = variantColorEl.getAttribute('data-name');

      // loop through product slides - add data-attribute for matches. just checking if color is found in data-alt
      for (let i = 0; i < imageSlides.length; i++) {

        let imageSlide = imageSlides[i];
        let slideAlt = imageSlide.getAttribute('data-alt');
        let slideAltTextArray = slideAlt ? slideAlt.split(',').map(s => s.trim()) : [];

        if (slideAltTextArray.some(val => val.toLowerCase() === selectedColor.toLowerCase())) {
          imageSlides[i].setAttribute('data-status', 'active');
        } else {
          imageSlides[i].setAttribute('data-status', 'inactive');
        }

      }

      // Only destroy if Flickity is already initialized
      if (flkty) {
        flkty.destroy();
      }

      // Reinitialize Flickity with only active slides
      flkty = new Flickity(productSlideshow, {
        cellSelector: '.slide[data-status="active"]',
        prevNextButtons: false,
        wrapAround: false,
        pageDots: false,
        speed: 700,
        cellAlign: 'left',
        on: {
          ready: function () {
            setTimeout(function() {
              updateArrowStates()
            }, 200);
            
          }
        }
      });

      // Update arrows whenever the slide changes
      flkty.on('change', updateArrowStates);

      // Now that the slideshow is rebuilt for this color, advance to the slide that
      // also matches the other currently-selected options (length, etc.), not just color.
      let variantOptionsSelected = getSelectedVariantOptions(variantColorEl);
      advanceToMatchingSlide(variantOptionsSelected);
    }

    // Gather all currently-selected variant options: the clicked option plus the
    // checked option from every other group (color, length, etc.). Also updates the
    // .selected class so the clicked group is excluded from the "other groups" scan.
    function getSelectedVariantOptions(variantOptionEl) {
      let variantOptionsSelected = [];
      let variantOptionValue = variantOptionEl.getAttribute("data-name");

      // find all .product-form__input elements and remove selected class from them
      let productFormInputEls = document.querySelectorAll(".product-form__input");
      productFormInputEls.forEach((productFormInputEl) => {
        productFormInputEl.classList.remove("selected");
      });

      // find the closest product-form__input element and add selected class to it.
      let productFormInputEl = variantOptionEl.closest(".product-form__input");
      if (productFormInputEl) {
        productFormInputEl.classList.add("selected");
      }

      // add the clicked variant option name to the variantOptionsSelected array
      variantOptionsSelected.push(variantOptionValue);

      // loop through all product-form__input elements that don't have the class
      // selected and find checked radio inputs (the other option groups)
      let uncheckedProductFormInputEls = document.querySelectorAll(
        '.product-form__input:not(.selected) input[type="radio"]:checked',
      );
      uncheckedProductFormInputEls.forEach((uncheckedProductFormInputEl) => {
        variantOptionsSelected.push(
          uncheckedProductFormInputEl.value.replace('"', ""),
        );
      });

      return variantOptionsSelected;
    }

    // Advance the slideshow to the currently-active slide that best matches the full
    // set of selected variant options. Exact match wins; otherwise fall back to the
    // slide with the highest number of matching options.
    function advanceToMatchingSlide(variantOptionsSelected) {
      let imageSlides = productSlideshow.querySelectorAll(
        '.slide[data-status="active"]',
      );

      let foundMatch = false;

      // loop through product slides and find first matching slide with the full
      // set of selected variant options - EXACT MATCH
      for (let i = 0; i < imageSlides.length; i++) {
        let imageSlide = imageSlides[i];
        let slideAlt = imageSlide.getAttribute("data-alt");
        let slideAltTextArray = slideAlt.split(",");

        if (arraysHaveExactMatch(variantOptionsSelected, slideAltTextArray)) {
          // get the flickity cell index by finding the position of this slide
          let flickityIndex = flkty.cells.findIndex(
            (cell) => cell.element === imageSlide,
          );
          flkty.select(flickityIndex, false, true);
          foundMatch = true;
          break;
        }
      }

      // if no exact match, fall back to the slide with the most matching options
      if (!foundMatch) {
        let highestMatch = { element: null, matchCount: 0 };

        for (let i = 0; i < imageSlides.length; i++) {
          let imageSlide = imageSlides[i];
          let slideAlt = imageSlide.getAttribute("data-alt");
          let slideAltTextArray = slideAlt.split(",");

          const result = countMatches(variantOptionsSelected, slideAltTextArray, i);

          if (result.matchCount > highestMatch.matchCount) {
            highestMatch = { element: imageSlide, matchCount: result.matchCount };
          }
        }

        if (highestMatch.element) {
          let flickityIndex = flkty.cells.findIndex(
            (cell) => cell.element === highestMatch.element,
          );
          flkty.select(flickityIndex, false, true);
        }
      }
    }

    // change product slideshow images based on product variant selection
    let variantOptionEls = document.querySelectorAll('.variant-option:not(.color-swatch)');
    variantOptionEls.forEach((variantOptionEl) => {
      variantOptionEl.addEventListener('click', function () {
          productSlideshowSelect(variantOptionEl);
      });
    });

    // when color swatch is clicked on, need to rebuild entire slideshow with only images that include color
    let variantColorEls = document.querySelectorAll('.variant-option.color-swatch');
    variantColorEls.forEach((variantColorEl) => {
      variantColorEl.addEventListener('click', function () {
          productSlideshowBuild(variantColorEl);
      });
    });
  }

  // universal flickity slideshows
  let slideshowsWithTextEls = document.querySelectorAll('.slideshow_with_text');
  slideshowsWithTextEls.forEach((slideshowWithTextEl) => {
    let slides = slideshowWithTextEl.querySelector('.slides');
    var flkty = new Flickity(slides, {
      cellSelector: '.cell',
      pageDots: false,
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      wrapAround: true,
    });
    let nextArrow = slideshowWithTextEl.querySelector('.arrow.next');
    nextArrow.addEventListener('click', function (e) {
      e.preventDefault();
      flkty.next();
    });
    let prevArrow = slideshowWithTextEl.querySelector('.arrow.previous');
    prevArrow.addEventListener('click', function (e) {
      e.preventDefault();
      flkty.previous();
    });
  });
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    // if header hamburger menu is clicked, add a class to the body to control colors
    if (event.currentTarget.classList.contains('header__icon--menu')) {
      document.querySelector('body').classList.toggle('menu_open');
    }
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

if (typeof BSS_B2B !== "undefined" && window.location.pathname.includes("/pages/trade-account-registration")) {
      let interval = setInterval(() => {
          if ($("#bss-b2b-registration-form-render").length > 0) {
            clearInterval(interval)
            const labelElements = $("#RegisterForm .field label,#bss-b2b-registration-form-render .formbuilder-text label")
            labelElements.each((idx, labelElement) => {
                const inputElement = $(labelElement).parent().find("input");
                if (inputElement.val()) {
                    $(labelElement).css({
                        "background-color": "var(--bg-body, #f5f5f5)",
                        "top": "-8px",
                        "font-size": "1rem",
                        "letter-spacing": ".04rem",
                        "height": "auto"
                    })
                }
                
                inputElement.focus(() => {
                    $(labelElement).css({
                        "background-color": "var(--bg-body, #f5f5f5)",
                        "top": "-8px",
                        "font-size": "1rem",
                        "letter-spacing": ".04rem",
                        "height": "auto"
                    })
                })
                inputElement.blur(() => {
                    if (inputElement.val()) {
                        $(labelElement).css({
                            "background-color": "var(--bg-body, #f5f5f5)",
                            "top": "-8px",
                            "font-size": "1rem",
                            "letter-spacing": ".04rem",
                            "height": "auto"
                        })
                    } else {
                        $(labelElement).css({
                            "background-color": "transparent",
                            "top": "11px",
                            "font-size": "1.3rem",
                            "letter-spacing": ".1rem",
                            "height": "50px"
                        });
                    }
                })
            })
          }
      }, 400)
      setTimeout(()=>{
        clearInterval(interval)
      },4000)
  }
